window.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('gk-backstop')) {
    // Scroll to bottom, hope all images will be toggled.
    window.scrollTo(0, document.body.scrollHeight);
    setTimeout( () => window.scrollTo( 0, 0 ), 150 );
    setTimeout( () => console.log('backstopjs_ready'), 500);
  }

  // Add classes to the button so it inherits the customizer styles.
  const submitButton = document.getElementById('wp-submit');
  if (submitButton) {

    submitButton.classList.add('btn', 'btn-primary');

    const previousElement = submitButton.previousElementSibling;
    if( previousElement ) {
      previousElement.classList.add('btn', 'btn-primary', 'btn-outline');
    }
  }

  // Add class to login_error.
  const login_error = document.getElementById('login_error');
  if (login_error) {
    login_error.classList.add( 'text-error', 'mb-4' );
  }

  // Remove backtoblog element.
  const backtoblog = document.getElementById('backtoblog');
  if( backtoblog ) {
    backtoblog.parentNode.removeChild(backtoblog);
  }

  const login_form = document.getElementById('login');
  if( login_form ) {

    const innerWrapper = document.createElement('div');
    innerWrapper.className = 'login-card';

    // Rebase all content into '.login-inner'.
    innerWrapper.innerHTML = login_form.innerHTML;

    // Make empty.
    login_form.innerHTML = '';

    login_form.insertAdjacentElement('afterbegin', innerWrapper);

    const nav = document.getElementById('nav');
    if( nav ) {
      const navParent = nav.parentNode;
      if (navParent) {
        navParent.insertAdjacentElement('afterend', nav);
      }
    }

    setTimeout( () => {
      document.body.classList.add( 'login--loaded' );
      document.body.classList.remove( 'login--loading' );
    }, document.body.classList.contains( 'gk-backstop' ) ? 1 : 150 );
  }
});
